import { _ as __assign } from '../../chunks/bundle-BXYHgzRj.js';
import React__default from 'react';
import { S as SuggestedMentionListView } from '../../chunks/bundle-CwopwRQp.js';
import '../../chunks/bundle-DNnUvjnZ.js';
import '../../chunks/bundle-CqMQE3-R.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-u-vzK-oc.js';
import '../../chunks/bundle-DGC3rWK4.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Dwpc_MJZ.js';
import '../../chunks/bundle-DWyboFhb.js';
import '../../chunks/bundle-ClfkSu0m.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-Cytf5OXn.js';
import '../../chunks/bundle-DyTMSX7q.js';

var SuggestedMentionList = function (props) {
    return (React__default.createElement(SuggestedMentionListView, __assign({}, props)));
};

export { SuggestedMentionList, SuggestedMentionList as default };
//# sourceMappingURL=SuggestedMentionList.js.map
